import React from 'react'
import { getQueryParam, stripHttpProtocol } from '../../../../shared/helpers'
import { useAppSelector } from '../../hooks/useStore'
import passportImg from '../../assets/img/passportLogo.svg'
import ProgressBar from '../ProgressBar'

function ContentImage() {
  const availability = getQueryParam(location.search, 'availability')
  const { videoDetails } = useAppSelector((state) => state.content)

  const {
    assetMezzanine,
    is_mvod,
    expired,
    expire_date,
    duration,
    seconds_watched,
  } = videoDetails
  const newSecondsWatched = seconds_watched

  const formattedExpiredDate = new Date(expire_date!)
  return (
    <div
      className="video-detail-screen__content-image"
      style={{
        backgroundImage: `url(${stripHttpProtocol(
          assetMezzanine
        )}?crop=830x466&format=webp)`,
      }}
    >
      <div
        className="video-player-image-preload"
        style={{
          backgroundImage: `url(${stripHttpProtocol(
            assetMezzanine
          )}?crop=1920x1080&format=webp)`,
        }}
      />

      {is_mvod && (
        <div className="video-detail-screen__passport-triangle">
          <img
            className="video-detail-screen__passport-logo"
            src={passportImg}
            alt={'passport logo'}
          />
        </div>
      )}
      {(expired || availability === 'not_yet_available') && (
        <div className="video-image-overlay">
          {expired && (
            <p className="video-image-message">
              This video expired on{' '}
              {`${
                formattedExpiredDate.getMonth() + 1
              }/${formattedExpiredDate.getDate()}/${formattedExpiredDate.getFullYear()} `}
            </p>
          )}
          {availability === 'not_yet_available' && (
            <p className="video-image-message">
              This video is not currently available.
            </p>
          )}
        </div>
      )}
      {newSecondsWatched > 0 && (
        <ProgressBar current={newSecondsWatched} total={duration} />
      )}
    </div>
  )
}

export default ContentImage
